var React = require('react');

function BookmarkAdded (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 21V5C5 4.45 5.196 3.979 5.588 3.587C5.97933 3.19567 6.45 3 7 3H17C17.55 3 18.021 3.19567 18.413 3.587C18.8043 3.979 19 4.45 19 5V21L12 18L5 21Z","fill":"black"}));
}

BookmarkAdded.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BookmarkAdded;

BookmarkAdded.default = BookmarkAdded;
